/**
 * region for libraries*/
import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

export class ConfirmationModal extends Component {
    static displayName = ConfirmationModal.name;

    constructor(props) {
        super(props);

        this.state = {
            show: true
        }

        this.toggle = this.toggle.bind(this);
        this.close = this.close.bind(this);
    }

    handleOnAccept() {
        if (this.props.onAccept) {
            this.props.onAccept();
        }
        this.close();
    }

    toggle() {
        this.setState(prevState => ({
            show: !prevState.show
        }));
    }

    close() {
        this.setState({ show: false });
        if (this.props.onClose) {
            this.props.onClose();
        }
    }

    //static getDerivedStateFromProps(nextProps, prevState) {
    //    if (nextProps.show !== prevState.show) {
    //        return { show: nextProps.show };
    //    }
    //}

    render() {

        const text = this.props.text || 'Are you sure to continue?';

        const acceptButtonClass = (this.props.acceptButton && this.props.acceptButton.className) || 'btn';
        const acceptButtonText = (this.props.acceptButton && this.props.acceptButton.text) || 'Yes';

        return <Modal zIndex={9999} isOpen={this.state.show} toggle={this.close} className={this.props.className}>
            {this.props.title && <ModalHeader toggle={this.close}>{this.props.title}</ModalHeader>}
            <ModalBody className="text-center font-size-xl">{text}</ModalBody>
            <ModalFooter>
                <Button color="primary" className={acceptButtonClass} onClick={this.handleOnAccept.bind(this)}>{acceptButtonText}</Button>{' '}
                <Button color="secondary" onClick={this.close}>Cancel</Button>
            </ModalFooter>
        </Modal>;
    }

}
